import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'percentage' })
export class PercentagePipe implements PipeTransform {
    transform(input, round = false, seperator = '-'): string {

        if (!Array.isArray(input) && (typeof input === 'string' || input instanceof String)) {

          input = input.replace(/\[|]/g, '');
          input = input.split(',');
        } else if (!Array.isArray(input) && typeof input === 'number') {
          input = [input];
        }

        if (input) {
          input.map((val) => {
            val = parseFloat(val);

            if (round) {
              val = Math.round(val);
            }

            return val.toFixed(val % 1 === 0 ? 0 : 2);
          });

          return input.join(seperator) + '%';
        }

        return '';
    }
}
